/**
 * Shared primary CTA — B2C `public/mobile/light.html` light theme (--primary #8E86FF, --primary-depth #7B6EE8).
 */

/** Brand primary (buttons, key actions) — matches B2C `public/mobile/light.html` */
export const LANDING_PRIMARY = '#8E86FF';

const landingCtaGradient =
  'bg-[#8E86FF] shadow-lg shadow-[rgba(142,134,255,0.35)] transition-all hover:bg-[#7B6EE8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8E86FF]';

/** Default marketing sections: symmetric vertical padding */
export const landingSectionY = 'py-12 md:py-16';

/** Primary pill / bar CTA (features, works-best-for) */
export const landingPrimaryCtaMd = `inline-flex items-center justify-center gap-2 rounded-xl px-8 py-3.5 text-sm font-semibold text-white ${landingCtaGradient}`;

/** Hero / final CTA band — larger tap target */
export const landingPrimaryCtaLg = `inline-flex items-center justify-center gap-2 rounded-2xl px-6 py-3 text-base font-semibold text-white sm:px-8 sm:py-4 sm:text-lg ${landingCtaGradient}`;

/**
 * Same size as `landingPrimaryCtaLg` but for use on `#8E86FF` panels (light.html `.btn-cta`: white + brand text).
 */
export const landingPrimaryCtaLgOnBrand = `inline-flex items-center justify-center gap-2 rounded-2xl border-2 border-white bg-white px-6 py-3 text-base font-semibold text-[#8E86FF] shadow-md shadow-black/10 transition-all hover:bg-white/95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:px-8 sm:py-4 sm:text-lg`;

/** Hero email submit (icon-only) */
export const landingPrimaryCtaIcon = `flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-white sm:h-12 sm:w-12 ${landingCtaGradient}`;

/** Demo / lead form full-width submit */
export const landingFormSubmitClass = `w-full flex items-center justify-center gap-2 rounded-xl py-3.5 text-sm font-semibold text-white ${landingCtaGradient}`;
